import { createRoutine } from 'redux-saga-routines'

export const SET = 'CATEGORIES/SET'
export const CONTENT = createRoutine('CATEGORIES/CONTENT')
